// @flow
import * as React from "react";
import ReactModal from "react-modal";

import { THEME_WIDTH } from "../commons/theme";

import catalog from "./catalog";

type Props = {
  match: { params: { name: string } }
};

class BottleDetail extends React.Component<Props> {
  closeModal = () => {
    location.hash = ""; // eslint-disable-line
  };

  render() {
    const { name } = this.props.match.params;

    const bottle = catalog.find(bottle => bottle.name === name);
    if (!bottle) {
      return null;
    }

    return (
      <ReactModal
        isOpen
        onRequestClose={this.closeModal}
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        style={{
          overlay: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          content: {
            position: "static",
            background: "#17161b",
            color: "#FFF",
            maxWidth: THEME_WIDTH,
            margin: 10,
            top: "auto",
            bottom: "auto",
            left: "auto",
            right: "auto",
            maxHeight: "calc(100vh - 80px)",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-around"
          }
        }}
      >
        {bottle.img && (
          <div>
            <img
              src={`bottles/${bottle.img}`}
              alt={bottle.name}
              title={bottle.name}
              style={{ height: 700, margin: 20 }}
            />
          </div>
        )}
        <div style={{ flex: 1, minWidth: 300, textAlign: "center" }}>
          <h3>{bottle.name}</h3>
          <div
            style={{ textAlign: "justify" }}
            dangerouslySetInnerHTML={{ __html: bottle.html }}
          />
        </div>
      </ReactModal>
    );
  }
}

export default BottleDetail;



// WEBPACK FOOTER //
// ./src/NosBouteilles/BottleDetail.js